import { faPencil } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from '../../CardHeader.module.scss';
import type { ImageType } from '../../types';
import { toFriendlyName } from '../../utilities';

type PicturePreviewButtonLabelProps = {
  type: ImageType;
  isLocked: boolean | undefined;
  canLock: boolean | undefined;
};

export const PicturePreviewButtonLabel: React.FC<PicturePreviewButtonLabelProps> = ({
  type,
  isLocked,
  canLock,
}) => {
  return (
    <div className={styles['picture-label']}>
      <span className={styles['picture-label-text']}>{toFriendlyName(type)}</span>
      {(!isLocked || canLock) && (
        <span className={styles['picture-label-icon']}>
          <FontAwesomeIcon icon={faPencil} />
        </span>
      )}
    </div>
  );
};
